import React from "react";
import { useChecklistRouteHook } from "../../hooks/useChecklistRouteHook";
import { useDispatch } from "react-redux";
import { isArray } from "lodash";
import { loanFetchedDataUwRequirementsSet } from "../../redux/reducers/loanFetchedDataReducer";
import { sidebarClose } from "../../redux/actions/sidebarActions";
import CommentsRenderer from "../renderers/CommentsRenderer";

const LoanConditionCommentInput = ({
  loanId,
  conditionId,
  inputTypeBasic = false,
}) => {
  const {
    loading,

    addCommentToUnderwritingRequirement,
  } = useChecklistRouteHook();

  const dispatch = useDispatch();

  const handleOnSubmit = (comm) => {
    // console.log("COMMENT TO SUBMIT", comm);
    // return;
    addCommentToUnderwritingRequirement({
      dealId: loanId,
      requirementId: conditionId,
      commentText: comm,
      onSuccessFn: (updatedConditions) => {
        if (isArray(updatedConditions)) {
          dispatch(loanFetchedDataUwRequirementsSet(updatedConditions));
        } else {
          dispatch(loanFetchedDataUwRequirementsSet(null));
          dispatch(sidebarClose());
        }
      },
    });
  };

  return (
    <CommentsRenderer
      // onAddComment={() => {}}
      onAddComment={handleOnSubmit}
      loading={loading}
      inputTypeBasic={inputTypeBasic}
      onlyInput
    />
  );
};
export default LoanConditionCommentInput;
